import Vue from 'vue';

const state = {
  questionsOfTheDay: {},
};

const getters = {
  get: state => state.questionsOfTheDay,
  all: state => {
    return Object.values(state.questionsOfTheDay);
  },
  getByDate: state => date => {
    return state.questionsOfTheDay[date];
  },
};

const mutations = {
  setByDate(state, { date, qotd }) {
    Vue.set(state.questionsOfTheDay, date, qotd);
  },
  set(state, questionsOfTheDay) {
    questionsOfTheDay.forEach(qotd => {
      state.questionsOfTheDay[qotd.date] = qotd;
    });
  },
};

const actions = {
  fetchLastWeekQuestionsOfTheDay({ commit, rootGetters }) {
    return rootGetters['session/ajax'].get('/questions_of_the_day').then(response => {
      response.data.qotds.forEach(qotd => {
        commit('setByDate', { date: qotd.date, qotd });
      });
      return response.data;
    });
  },
  fetchQuestionOfTheDayByDate({ commit, rootGetters }, date) {
    if (!date) {
      return {};
    }
    return rootGetters['session/ajax'].get(`/questions_of_the_day/${date}`).then(response => {
      const qotd = response.data.qotd;
      commit('setByDate', { date, qotd });
      return response.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
